import {PureComponent} from 'react';
import classnames from 'classnames';
import {Button} from '@br/br-components';

import ErrorMessages from './errorMessages';
import PasswordInput from './passwordInput';

// TODO: NR-293 - Convert this to a molecule
class EmailLoginForm extends PureComponent {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.showResetPasswordFlow = this.showResetPasswordFlow.bind(this);
    this.state = {
      errors: this.props.errors,
    };
  }

  onSubmit(event) {
    event.preventDefault();
    const emailInput = event.target.querySelector("input[name='email']");
    const passwordInput = this._passwordField.state;
    const {onboarding, screen, userAgent} = this.props;
    this.props
      .onSubmit(
        {
          email: emailInput.value,
          password: passwordInput.value,
        },
        userAgent
      )
      .then(() => {
        this.props.stepCompleted(true, true);
        this.props.trackEvent({
          tag_manager_event: 'login',
          accountType: 'email',
          screen,
          loginSuccess: true,
          onboarding,
        });
      })
      .catch((err) => {
        this.setState({errors: [err]});
        this.props.trackEvent({
          tag_manager_event: 'login',
          accountType: 'email',
          screen,
          loginSuccess: false,
          onboarding,
        });
      });
  }

  showResetPasswordFlow() {
    this.props.stepCompleted();
  }

  render() {
    const classNames = classnames({
      emailLoginForm: true,
      atom: true,
      errors: this.state.errors.length,
    });

    return (
      <form onSubmit={this.onSubmit} className={classNames}>
        <h1>Sign In with Email</h1>
        <p>Enter your email address and password.</p>
        <input type="text" name="email" placeholder="Email address" autoFocus={true} />
        <PasswordInput
          ref={(elem) => {
            this._passwordField = elem;
          }}
        />
        <ErrorMessages errors={this.state.errors} errorSet="email" />
        <div className="legalText">
          <p>
            By proceeding, you agree to the terms and conditions of the Bleacher Report{' '}
            <a href="https://bleacherreport.com/pages/terms">Terms of Use</a> and{' '}
            <a href="https://www.warnermediaprivacy.com/policycenter/b2c/wm/">Privacy Policy</a>.
          </p>
        </div>
        <Button classes="submit" type="submit">
          Sign In
        </Button>
        <Button classes="forgot" onClick={this.showResetPasswordFlow}>
          Forgot password?
        </Button>
        {this.props.children}
      </form>
    );
  }
}

EmailLoginForm.defaultProps = {
  errors: [],
  stepCompleted: () => {},
  trackEvent: () => {},
};

export default EmailLoginForm;
